import * as signalR from "@microsoft/signalr";
// https://pos.btmc.vn:8686
const SOCKET = import.meta.env.VITE_APP_SOCKET_URL || "https://pos.btmc.vn:8686";

// Singleton instance để tránh tạo nhiều connection
let sharedConnection = null;
let connectionPromise = null;

export class SignalRService {
  constructor(url = SOCKET, useShared = false) {
    this.manuallyStopped = false;

    // Validate URL
    if (!url) {
      throw new Error("SignalR URL is required. Please set VITE_APP_SOCKET_URL in your .env file");
    }

    // Nếu useShared = true, sử dụng shared connection
    if (useShared && sharedConnection) {
      this.connection = sharedConnection;
      this.isShared = true;
    } else {
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(url, {
          skipNegotiation: true,
          transport: 1,
        })
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.None)
        .build();

      if (useShared) {
        sharedConnection = this.connection;
        this.isShared = true;
      } else {
        this.isShared = false;
      }
    }

    // Tự động xử lý khi bị mất kết nối (do sleep / mạng rớt lâu)
    this.connection.onclose((error) => {
      console.warn("SignalR connection closed:", error);

      // Nếu người dùng chủ động stop thì không tự reconnect
      if (this.manuallyStopped) {
        console.log("SignalR was stopped manually, skip auto-reconnect");
        return;
      }

      // Thử start lại sau khi close
      this.start();
    });
  }

  async start() {
    // Mỗi lần start thì clear cờ manuallyStopped để cho phép auto reconnect lại
    this.manuallyStopped = false;

    // Nếu connection đã connected, không cần start lại
    if (this.connection.state === signalR.HubConnectionState.Connected) {
      console.log("SignalR already connected");
      return;
    }

    // Nếu đang connecting, đợi nó hoàn thành
    if (this.connection.state === signalR.HubConnectionState.Connecting) {
      console.log("SignalR is connecting, waiting...");
      if (connectionPromise) {
        return await connectionPromise;
      }
    }

    try {
      connectionPromise = this.connection.start();
      await connectionPromise;
      console.log("SignalR connected successfully");
      connectionPromise = null;
    } catch (error) {
      console.error("SignalR connection error:", error);
      connectionPromise = null;
      setTimeout(() => this.start(), 5000); // Thử kết nối lại
    }
  }

  stop() {
    // Không stop shared connection
    if (this.isShared) {
      console.log("Cannot stop shared SignalR connection");
      return;
    }

    if (this.connection) {
      this.manuallyStopped = true;
      this.connection.stop();
      console.log("SignalR stopped!");
    }
  }

  on(event, callback) {
    this.connection.on(event, callback);
  }

  off(event, callback) {
    if (callback) {
      this.connection.off(event, callback);
    } else {
      this.connection.off(event);
    }
  }

  send(methodName, ...args) {
    return this.connection.invoke(methodName, ...args);
  }

  getState() {
    return this.connection.state;
  }
}

// Helper để lấy shared instance
export function getSharedSignalR() {
  if (!sharedConnection) {
    new SignalRService(SOCKET, true);
  }
  return new SignalRService(SOCKET, true);
}
